var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.655,423.75H38.345C17.167,423.75,0,406.582,0,385.405V126.646 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345v258.759 C512,406.582,494.833,423.75,473.655,423.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.828,255.975h15.334l81.77-53.574v53.574h44.138v-53.574l81.77,53.574h15.334 c4.875,0,8.828-3.953,8.828-8.828v-7.002l-70.155-45.963H256v-44.138h-70.155L256,104.081v-7.002c0-4.559-3.456-8.309-7.891-8.777 h-16.348l-81.693,53.523V88.301H105.93v53.523L26.894,90.041c-9.242,2.888-16.973,9.186-21.741,17.415l65.002,42.588H0v44.138 h70.155L0,240.145v7.002C0,252.022,3.953,255.975,8.828,255.975z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,158.871 141.241,158.871 141.241,88.25 114.759,88.25 114.759,158.871 0,158.871  0,185.354 114.759,185.354 114.759,255.975 141.241,255.975 141.241,185.354 256,185.354  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.254,102.894l72.636,47.149h16.214L14.643,96.516C12.271,98.385,10.126,100.525,8.254,102.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M166.283,150.044l88.374-57.366c-1.536-2.599-4.246-4.427-7.485-4.427h-1.909l-95.194,61.793 H166.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M89.474,194.182L1.269,251.437c1.519,2.663,4.273,4.537,7.559,4.537h1.665l95.196-61.793H89.474 V194.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M255.86,247.841l-82.666-53.658H156.98l93.874,60.935 C253.666,253.812,255.595,251.076,255.86,247.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M383.828,172.193c0,0-3.691-14.766-14.766-22.15c0,0,11.074,18.457,11.074,33.224L383.828,172.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M366.754,156.158c0,0,7.73,4.729,11.882,12.459l-3.346,7.73 C375.292,176.345,372.523,165.387,366.754,156.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M358.218,157.888c0,0,13.382,4.153,19.726,12.806l-3.807,5.768 C374.137,176.461,369.062,166.656,358.218,157.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M356.257,164.579c0,0,14.074,2.191,20.419,8.883l-1.615,6.345 C375.061,179.807,367.331,170.578,356.257,164.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M356.718,169.194c0,0,13.612,1.385,19.842,8.536c6.229,7.153-2.307,4.96-2.307,4.96 S367.101,174.5,356.718,169.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M383.828,172.193c0,0,3.691-14.766,14.766-22.15c0,0-11.074,18.457-11.074,33.224L383.828,172.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M400.901,156.158c0,0-7.73,4.729-11.882,12.459l3.346,7.73 C392.365,176.345,395.134,165.387,400.901,156.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M409.438,157.888c0,0-13.382,4.153-19.726,12.806l3.807,5.768 C393.518,176.461,398.594,166.656,409.438,157.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M411.4,164.579c0,0-14.074,2.191-20.419,8.883l1.615,6.345 C392.596,179.807,400.324,170.578,411.4,164.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M410.937,169.194c0,0-13.612,1.385-19.842,8.536c-6.229,7.153,2.307,4.96,2.307,4.96 S400.555,174.5,410.937,169.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M383.828,150.044c0,0-3.691,7.767,0,11.651C387.52,157.811,383.828,150.044,383.828,150.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M380.15,151.972c0,0-0.495,8.586,4.386,10.794C386.495,157.779,380.15,151.972,380.15,151.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M387.506,151.972c0,0,0.495,8.586-4.386,10.794C381.161,157.779,387.506,151.972,387.506,151.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M388.715,156.925c0,0-3.221,7.975-8.578,7.884C380.498,159.463,388.715,156.925,388.715,156.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M378.941,156.925c0,0,3.221,7.975,8.578,7.884C387.158,159.463,378.941,156.925,378.941,156.925z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD255"
    },
    cx: 383.82,
    cy: 175.89,
    rx: 11.08,
    ry: 14.766
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M358.526,190.958l-2.538-3.923c0,0-7.383,1.769-9.152-3.768l-2.846-0.231 c0,0,0.384-3.768,3.691-4.307c0,0,1.999-2.461,5.537-1.999c3.538,0.461,5.384,3.46,7.422,4.23c2.038,0.769,2.269,3.307,2.269,3.307 l15.535,15.919c0,0-4.46,5.692-8.46,7.537S351.296,200.572,358.526,190.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M408.977,193.88c0,0,6.461,4.384,6.691,16.497h-10.729c0,0,0.116-8.191-1.961-12.574L408.977,193.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M407.593,194.343c0,0,8.075,2.654,13.036-3.691l-8.422-1.153L407.593,194.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M405.17,185.46l8.2,2.764c1.034,0.349,1.399,1.629,0.674,2.445 c-3.111,3.505-12.397,11.903-27.37,11.903c-19.496,0-24.533-12.267-24.764-13.19c-0.231-0.922-1.269-8.422-1.269-8.422l8.306-0.922 L405.17,185.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "325.44,298.403 346.913,298.403 335.838,319.854 324.764,305.088  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "442.216,298.403 420.744,298.403 431.818,319.854 442.892,305.088  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD25A"
    },
    d: "M325.351,334.621c-10.593,0-18.699-5.685-19.117-5.981l8.536-12.052 c0.071,0.046,7.223,4.906,14.516,2.697c7.38-2.228,12.225-10.937,14.991-17.856l13.71,5.486 c-5.816,14.542-14.112,23.479-24.651,26.569C330.58,334.293,327.893,334.621,325.351,334.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD25A"
    },
    d: "M442.305,334.621c10.593,0,18.699-5.685,19.117-5.981l-8.536-12.052 c-0.071,0.046-7.223,4.906-14.516,2.697c-7.38-2.228-12.225-10.937-14.991-17.856l-13.71,5.486 c5.816,14.542,14.112,23.479,24.651,26.569C437.076,334.293,439.764,334.621,442.305,334.621z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M431.818,257.098h-95.98v-35.47c0-4.875,3.953-8.828,8.828-8.828h78.325 c4.875,0,8.828,3.953,8.828,8.828L431.818,257.098L431.818,257.098z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M362.025,238.641l-1.153-7.383c-5.422-0.231-8.536-6.575-8.536-6.575l-4.384,2.422 C352.565,238.179,362.025,238.641,362.025,238.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M419.82,231.027c1.615-1.23,5.153-1.692,5.153-1.692c-2.538-2.615-5.306-0.769-5.306-0.769 c2.307-2.153,1-5.229,1-5.229c0,1-1.615,1.692-1.615,1.692c0.077-1.999-1.999-3.923-1.999-3.923l-1.077,1.769 c-0.692-1.692-3.153-2.999-3.153-2.999l-1,4.153c-2.307-1.999-6.383-1.846-6.383-1.846l0.769,1.923 c-2.461,0.076-9.152,1.461-13.075,1.922s-7.075-0.615-7.075-2.383c0-1.482,3.428-1.665,4.911-1.687 c1.049,0.234,2.368,0.612,4.222,1.169c3.46,1.038,5.487-0.466,5.487-0.466c-1.212-0.461-1.346-1-1.346-1 c2.595-1.5,5.03-1.13,5.03-1.13c-0.865-1.903-4.615-1.788-4.615-1.788c0.981-0.519,1.73-2.134,1.73-2.134 c-0.231,0.231-2.362,0.754-5.272,1.144c-2.19,0.295-4.247,1.96-5.097,2.73c-2.31-0.177-8.342-0.25-7.281,3.933 c1.308,5.153,11.69,3.307,18.073,2.307s9.69-0.153,11.074,0.692c1.385,0.846-0.589,3.712-7.075,2.538 c-5.605-1.014-8.692-1.043-10.387-0.865c-1.879,0.12-3.481,0.626-4.61,0.865c-2.538,0.538-12.306,3.999-14.151-1 c-1.846-5-10.844,8.152-10.844,8.152l0.703,0.836l-2.395-0.567c-3.23,4.326-12.92,5.653-12.92,5.653s-1.442-2.595-2.654-2.942 c-1.212-0.346-1.73,1.557-1.73,1.557s-1.442,0.057-1.557,1.385c-0.116,1.326,1.038,1.442,1.038,1.442s-1.385,2.019,0.922,2.595 c0,0-0.173,2.826,3.23,0.865c10.11,1.274,17.482-3.917,20.674-6.749c2.087,0.134,5.339,0.067,7.839-1.23 c3.999-2.077,8.614-4.692,11.305-3.691c0,0,2.154,6.614-6.306,6.767c0,0-1.251-1.582-2.51-1.582c-0.543,0-1.108,0.652-0.934,1.238 c0,0-1.476-0.087-1.737,0.782c-0.213,0.708,0.303,1.519,1.389,1.389c0,0-0.738,1.086,0,1.737s1.651,0,1.651,0 s-0.391,1.346,0.521,1.476c0.78,0.111,1.813-1.163,2.109-1.55c1.354,0.211,10.591,1.276,12.586-8.413c0,0,4.615,1.999,9.152,1.615 s8.999,0.308,8.614,2.538c-0.503,1.617-1.495,1.51-1.495,1.51c-1.086-0.435-2.91-0.391-3.17,1.173 c-0.26,1.564,1.867,1.607,1.867,1.607c0.608,1.433,2.345,0.825,2.345,0.825c1.519,1.086,2.519-0.087,2.519-0.087 c0.652,0.565,1.324,0.67,1.954,0.13c0.608-0.521,0.267-3.996,0.209-5.236c-0.096-2.063-0.385-7.459-3.384-7.537 c-2.999-0.077-6.845,1.692-12.151-2.769c-0.277-0.233-0.547-0.381-0.821-0.579c2.511,0.233,4.31,0.914,6.051,1.194 C411.207,232.873,418.206,232.257,419.82,231.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M347.95,227.104c0,0-1.471,0.04-2.191-0.173c-1.235-0.364-1.385-2.307-0.057-2.654 c0,0-1.597-1.085-0.865-2.307c0.586-0.978,2.079-0.975,2.598-0.398c0,0-0.487-1.609,0.921-2.14c1.12-0.423,2.019,0.865,2.019,2.538 c0,0,1.674-1.362,2.538-0.461c0.602,0.628,0.429,1.453-0.577,3.172C351.309,226.436,347.95,227.104,347.95,227.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M346.131,226.393c0,0-0.781,1.346-3.04,0.521c0,0,1.954-0.913,2.215-1.694L346.131,226.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M345.305,222.441c0,0-1.216-0.781-2.562-0.738c0,0,1.997-1.476,3.691-0.173L345.305,222.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M348.129,220.356c0,0,0.391-1.433-0.391-2.215c0,0,1.607,0.695,1.824,1.997L348.129,220.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M351.69,221.833c0,0,0.781-1.737,0.087-2.562c0,0,2.084,1.216,1.216,3.214L351.69,221.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M347.62,241.134c0,0-0.836-1.711-1.914-1.705c0,0,2.268-0.825,3.249,1.12L347.62,241.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M345.793,243.315c0,0-1.491-1.186-2.462-0.716c0,0,1.693-1.72,3.414-0.386L345.793,243.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M346.84,246.391c0,0-1.905-0.021-2.383,0.946c0,0,0.28-2.397,2.458-2.4L346.84,246.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M348.582,248.37c0,0-0.781,1.346-3.04,0.521c0,0,1.954-0.913,2.215-1.694L348.582,248.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M382.909,247.686c0,0-0.64,1.102-2.49,0.427c0,0,1.502-0.536,1.715-1.177L382.909,247.686z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD255"
    },
    d: "M363.372,223.874c0,0-4.154,7.075-3.155,17.304c0,0,12.247-1.788,17.554-14.016 c0,0,1.293-0.523,1.797-1.779c0.429-1.068,0.394-2.827-1.663-2.817c0,0,0.616-1.23,1.365-1.519c0,0-1.326-0.519-2.884-0.173 c0,0,1.212-1.212,1.212-2.769c0,0-1.846,1.212-2.999,1.326c0,0-0.116-1.903,0.346-2.134c0,0-2.422,0.231-3.634,1.5 c0,0-0.808-1.096-0.75-2.25c0,0-2.25,0.981-3.115,2.422c0,0-0.692-0.75-0.634-1.5c0,0-1.615,1.961-1.961,2.999 c0,0-1.522-0.418-2.191,0.808C362.176,222.163,362.286,223.136,363.372,223.874z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M381.063,242.535c0,0-0.492-0.927-1.969-1.129c0,0,1.882-0.868,3.069,0.376L381.063,242.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M411.595,246.052c0,0-1.079,0.341-1.585,1.867c0,0-0.553-2.167,1.001-3.182L411.595,246.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M413.859,246.849c0,0-1.022,0.993-0.973,2.601c0,0-1.261-1.847-0.149-3.332L413.859,246.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M418.745,246.762c0,0-0.309,1.052,0.625,2.174c0,0-1.933-0.615-1.97-2.298L418.745,246.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M416.449,247.171c0,0-0.82,0.78-0.602,2.374c0,0-1.525-1.34-0.575-2.934L416.449,247.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M379.489,244.431c0,0-0.988-0.354-2.216,0.49c0,0,0.807-1.909,2.522-1.788L379.489,244.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M380.839,246.531c0,0-1.015-0.266-2.165,0.682c0,0,0.177-1.842,1.897-1.87L380.839,246.531z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M431.818,263.047c-8.006,0-8.006,7.221-16.011,7.221s-8.006-7.221-16.011-7.221 c-8,0-8,7.221-16,7.221c-7.993,0-7.993-7.221-15.986-7.221s-7.992,7.221-15.983,7.221c-7.994,0-7.994-7.221-15.989-7.221v-13.332 c7.994,0,7.994,7.221,15.989,7.221c7.992,0,7.992-7.221,15.983-7.221c7.993,0,7.993,7.221,15.986,7.221c8,0,8-7.221,16-7.221 c8.006,0,8.006,7.221,16.011,7.221s8.006-7.221,16.011-7.221V263.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M415.807,270.269c-8.006,0-8.006-7.221-16.011-7.221c-8,0-8,7.221-16,7.221 c-7.993,0-7.993-7.221-15.986-7.221s-7.992,7.221-15.983,7.221c-7.978,0-8-7.186-15.944-7.217c0.11,3.192,0.477,7.93,1.412,13.497 c6.494,0.86,7.085,7.051,14.531,7.051c7.992,0,7.992-7.222,15.983-7.222c7.993,0,7.993,7.222,15.986,7.222c8,0,8-7.222,16-7.222 c8.006,0,8.006,7.222,16.011,7.222c7.457,0,8.05-6.193,14.553-7.051c0.936-5.567,1.302-10.305,1.412-13.497 C423.818,263.083,423.796,270.269,415.807,270.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M415.807,283.601c-8.006,0-8.006-7.222-16.011-7.222c-8,0-8,7.222-16,7.222 c-7.993,0-7.993-7.222-15.986-7.222s-7.992,7.222-15.983,7.222c-7.446,0-8.038-6.191-14.531-7.051 c0.742,4.412,1.848,9.331,3.479,14.418c3.599,2.066,5.166,5.965,11.052,5.965c7.992,0,7.992-7.221,15.983-7.221 c7.993,0,7.993,7.221,15.986,7.221c8,0,8-7.221,16-7.221c8.006,0,8.006,7.221,16.011,7.221c5.899,0,7.465-3.907,11.076-5.971 c1.63-5.085,2.735-10.003,3.478-14.412C423.857,277.408,423.264,283.601,415.807,283.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M415.807,296.932c-8.006,0-8.006-7.221-16.011-7.221c-8,0-8,7.221-16,7.221 c-7.993,0-7.993-7.221-15.986-7.221s-7.992,7.221-15.983,7.221c-5.885,0-7.453-3.9-11.052-5.965 c2.031,6.338,4.884,12.911,8.866,19.041c0.671,0.138,1.363,0.256,2.186,0.256c7.992,0,7.992-7.222,15.983-7.222 c7.993,0,7.993,7.222,15.986,7.222c8,0,8-7.222,16-7.222c8.006,0,8.006,7.222,16.011,7.222c0.832,0,1.533-0.118,2.21-0.258 c3.982-6.132,6.835-12.706,8.866-19.044C423.273,293.025,421.706,296.932,415.807,296.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M415.807,310.264c-8.006,0-8.006-7.222-16.011-7.222c-8,0-8,7.222-16,7.222 c-7.993,0-7.993-7.222-15.986-7.222s-7.992,7.222-15.983,7.222c-0.823,0-1.515-0.118-2.186-0.256 c2.53,3.895,5.526,7.599,9.054,10.951c2.444-2.065,4.386-4.585,9.116-4.585c7.993,0,7.993,7.221,15.986,7.221c8,0,8-7.221,16-7.221 c4.749,0,6.691,2.532,9.149,4.6c3.535-3.357,6.537-7.066,9.071-10.968C417.34,310.146,416.639,310.264,415.807,310.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M408.945,320.974c-2.457-2.068-4.399-4.6-9.149-4.6c-8,0-8,7.221-16,7.221 c-7.993,0-7.993-7.221-15.986-7.221c-4.73,0-6.671,2.52-9.116,4.585c6.43,6.11,14.628,11.034,25.133,13.661 C394.324,331.997,402.517,327.078,408.945,320.974z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M399.796,249.715c-8,0-8,7.221-16,7.221c-7.993,0-7.993-7.221-15.986-7.221 s-7.992,7.221-15.983,7.221c-7.994,0-7.994-7.221-15.989-7.221c0,4.555,0,8.511,0,11.074c0,0.625,0.014,1.395,0.044,2.262 c7.944,0.031,7.967,7.217,15.944,7.217c7.992,0,7.992-7.221,15.983-7.221c7.993,0,7.993,7.221,15.986,7.221c8,0,8-7.221,16-7.221 c8.006,0,8.006,7.221,16.011,7.221c7.989,0,8.011-7.186,15.967-7.217c0.03-0.868,0.044-1.638,0.044-2.262c0-2.563,0-6.52,0-11.074 c-8.006,0-8.006,7.221-16.011,7.221C407.801,256.937,407.801,249.715,399.796,249.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M428.127,212.8c2.039,0,3.691,1.653,3.691,3.691v33.224v7.383c0,1.399,0,2.678,0,3.691 c0,0.625-0.014,1.395-0.044,2.262c-0.11,3.192-0.477,7.93-1.412,13.497c-0.742,4.409-1.848,9.327-3.478,14.412 c-2.031,6.339-4.884,12.914-8.866,19.044c-2.535,3.903-5.537,7.613-9.071,10.968c-6.428,6.103-14.621,11.022-25.117,13.646 c-10.505-2.626-18.703-7.551-25.133-13.661c-3.528-3.352-6.524-7.055-9.054-10.951c-3.982-6.131-6.835-12.703-8.866-19.041 c-1.631-5.087-2.738-10.007-3.479-14.418c-0.936-5.567-1.302-10.305-1.412-13.497c-0.03-0.868-0.044-1.638-0.044-2.262 c0-1.013,0-2.293,0-3.691v-7.383V216.49c0-2.039,1.653-3.691,3.691-3.691h88.596 M428.127,210.031H339.53 c-3.562,0-6.461,2.898-6.461,6.461v33.224v7.383v3.691c0,0.651,0.014,1.453,0.046,2.358c0.105,3.014,0.441,7.863,1.449,13.86 c0.858,5.106,2.061,10.086,3.573,14.804c2.34,7.299,5.429,13.929,9.181,19.704c2.763,4.253,5.949,8.106,9.468,11.451 c7.342,6.977,16.214,11.801,26.369,14.34l0.672,0.168l0.671-0.168c10.147-2.537,19.013-7.357,26.353-14.325 c3.528-3.35,6.72-7.208,9.487-11.468c3.753-5.777,6.841-12.407,9.181-19.709c1.512-4.714,2.713-9.693,3.572-14.797 c1.009-5.997,1.345-10.848,1.449-13.86c0.031-0.905,0.046-1.707,0.046-2.358v-3.691v-7.383v-33.224 C434.586,212.929,431.689,210.031,428.127,210.031L428.127,210.031z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "383.828,312.296 373.698,319.345 377.272,307.532 367.438,300.077 379.775,299.827  383.828,288.169 387.881,299.827 400.217,300.077 390.385,307.532 393.959,319.345 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M383.828,290.447l3.517,10.115l10.708,0.218l-8.535,6.47l3.102,10.251l-8.791-6.116l-8.791,6.116 l3.102-10.251l-8.534-6.47l10.708-0.218L383.828,290.447 M383.828,285.892l-1.412,4.064l-3.175,9.133l-9.667,0.198l-4.301,0.087 l3.428,2.6l7.704,5.842l-2.799,9.255l-1.246,4.118l3.532-2.457l7.936-5.523l7.936,5.523l3.532,2.457l-1.246-4.118l-2.799-9.255 l7.704-5.842l3.428-2.6l-4.301-0.087l-9.667-0.198l-3.175-9.133L383.828,285.892L383.828,285.892z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "361.581,283.502 351.451,290.551 355.025,278.739 345.191,271.284 357.528,271.032  361.581,259.374 365.633,271.032 377.971,271.284 368.137,278.739 371.711,290.551 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M361.581,261.653l3.517,10.115l10.708,0.218l-8.534,6.47l3.102,10.251l-8.791-6.116l-8.791,6.116 l3.102-10.251l-8.534-6.47l10.708-0.218L361.581,261.653 M361.581,257.098l-1.412,4.064l-3.175,9.133l-9.667,0.198l-4.301,0.087 l3.428,2.6l7.704,5.842l-2.799,9.255l-1.246,4.118l3.532-2.457l7.936-5.523l7.936,5.523l3.532,2.457l-1.246-4.118l-2.799-9.255 l7.704-5.842l3.428-2.6l-4.301-0.087l-9.667-0.198l-3.175-9.133L361.581,257.098L361.581,257.098z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "405.879,283.502 395.75,290.551 399.322,278.739 389.49,271.284 401.826,271.032  405.879,259.374 409.932,271.032 422.269,271.284 412.436,278.739 416.009,290.551 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M405.879,261.653l3.517,10.115l10.707,0.218l-8.534,6.47l3.102,10.251l-8.791-6.116l-8.791,6.116 l3.102-10.251l-8.534-6.47l10.708-0.218L405.879,261.653 M405.879,257.098l-1.412,4.064l-3.175,9.133l-9.667,0.198l-4.301,0.087 l3.428,2.6l7.704,5.842l-2.799,9.255l-1.246,4.118l3.532-2.457l7.936-5.523l7.936,5.523l3.532,2.457l-1.246-4.118l-2.799-9.255 l7.704-5.842l3.428-2.6l-4.301-0.087l-9.667-0.198l-3.175-9.133L405.879,257.098L405.879,257.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M442.216,298.403c-9.161,23.326-31.85,39.908-58.388,39.908s-49.227-16.583-58.388-39.908 l-13.738,5.375c11.317,28.814,39.345,49.3,72.126,49.3s60.809-20.486,72.126-49.3L442.216,298.403z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "391.211,212.8 380.137,212.8 376.445,201.725 387.52,201.725  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M409.668,212.8h-7.383l-2.461-7.383h3.37c2.397,0,4.524,1.534,5.282,3.807L409.668,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M369.062,212.8h-7.383l-0.842-2.525c-0.797-2.39,0.982-4.858,3.502-4.858h2.261L369.062,212.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M402.285,212.8h-11.074l-3.691-11.074h8.414c1.589,0,2.999,1.016,3.502,2.525L402.285,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M380.137,212.8h-11.074l-2.494-7.48c-0.589-1.768,0.727-3.594,2.591-3.594h7.286L380.137,212.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#509664"
    },
    d: "M410.937,187.19c-2.884,4.153-10.959,9.113-24.11,9.113c-10.836,0-17.805-6.543-20.132-9.123 c-0.567-0.628-0.863-1.431-0.863-2.278v-2.518c0-1.084,0.562-2.07,1.498-2.614c2.344-1.364,7.762-3.54,18.458-3.54 C399.055,176.231,410.937,187.19,410.937,187.19z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKy);
export default __webpack_public_path__ + "static/media/ky.a24adcc6a551a99b509332629856cdfc.svg";
export { ForwardRef as ReactComponent };